<template>
  <div class="modal is-active" v-if="show">
    <div v-on:click="close" class="modal-background"></div>
    <div :class="['modal-card', 'animated',iframe_class] ">
      <section class="modal-card-body has-text-centered editor-text">
        <!-- Setting up dynamic body content -->
        <iframe :height="height" :width="width" :class="iframe_class" :src="url + '&isPreview=true'"></iframe>
      </section>
    </div>
  </div>
</template>
<script>
  /* eslint-disable indent,no-new,no-undef,valid-jsdoc,no-useless-escape */
  import misc from '../mixins/misc'

  export default {
    components: {},
    props: ['url', 'height', 'width', 'iframe_class'],
    mixins: [
      misc
    ],
    data () {
      return {
        body: '',
        show: true,
        isProcessing: false
      }
    },
    methods: {
      /**
       * Displays popup
       * @return {void}
       */
      display () {
        this.show = true
      },
      /**
       * close popup
       * @return {void}
       */
      close () {
        this.show = false
        window.events.$emit('closingModal')
      }
    }
  }
</script>
<style scoped>
  .modal-card-body {
    overflow: hidden !important;
  }

  .modal-card {
    overflow: hidden !important;
  }

  .modal-card-body {
    text-align: left;
    background-color: #fff;
    font-size: .9em;
    padding: 0px !important;
  }

  iframe.onSiteWriteReview {
      height: 617px;
      width: 600px;
  }

  iframe.seoPage {
    height: 617px;
    width: 600px;
  }

  iframe.reviewTab {
    height: 480px;
    width: 600px;
  }

  .modal-card{
    height: 617px !important;
    width: 600px !important;;
  }

  .modal-card.reviewTab{
    height: 480px !important;
  }

  @media screen and (min-width: 768px), print {
    .modal-content, .modal-card {
      margin: 0 auto;
      height: 480px;
      width: 600px;
      overscroll-behavior: contain;
      overflow-y: hidden;
    }
    .modal-card.animated.onSiteWriteReview {
      height: 617px !important;
    }
    iframe.onSiteWriteReview .modal-content, .modal-card{
        height: 600px;
        width: 600px;
    }

    iframe.reviewTab .modal-content, .modal-card{
        height: 480px;
        width: 600px;
    }
    .modal-content, .modal-card::-webkit-scrollbar {
      display: none;
    }

    ::-webkit-scrollbar {
      width: 0px;
      overflow: hidden;
    }
  }

  @media screen and (max-width: 767px) {
    .modal-background {
      background-color: #fff;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/ModalIframe.vue